import script from "./Data-Collection-Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Data-Collection-Container.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__